module.exports = __webpack_public_path__ + "img/VEDRA.b7770f7c.png";